// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__u_jwG","container":"NotFound_container__69B4F","img":"NotFound_img__suQWQ","btnsContainer":"NotFound_btnsContainer__3p2mI"};